export { default } from './TaskDescBlock';



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/TaskDescBlock/index.js